import type MapFeature from '@/lib/map-feature'

/**
 * Presentation rows for a MapFeature as ordered `{ key: value }` pairs.
 * Returns `undefined` when no rows resolve to non-empty strings.
 */
export function getFeaturePresentationData(
  feature: MapFeature
): Array<Record<string, string>> | undefined {
  const rows = feature.presentation?.content?.[0] as
    | Array<Record<string, unknown>>
    | undefined
  if (!rows?.length) {
    return undefined
  }

  const output = rows
    .map((row) => {
      const [key, value] = Object.entries(row)[0] ?? []
      if (!key || value === undefined || value === null) {
        return null
      }
      const stringValue = String(value).trim()
      return stringValue ? { [key]: stringValue } : null
    })
    .filter((row): row is Record<string, string> => row !== null)

  return output.length > 0 ? output : undefined
}
